import { render, staticRenderFns } from "./VConfirmation.vue?vue&type=template&id=2a4c31dd"
import script from "./VConfirmation.vue?vue&type=script&lang=js"
export * from "./VConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports